"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendEmail = void 0;
const sendEmail = async (message) => {
    const resp = await fetch("https://golfsavers-functions.azurewebsites.net/api/sendEmail", {
        method: "POST",
        body: JSON.stringify(message),
        headers: {
            "Content-Type": "application/json",
        },
    });
    return resp;
};
exports.sendEmail = sendEmail;
